import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, path, type = "website", image }) => {
  const baseUrl = "https://jeekota.com";
  const defaultImage = "https://customer-assets.emergentagent.com/job_2515fe7f-9b3f-475c-8b2b-feb23747bb05/artifacts/qq6gufzs_WhatsApp%20Image%202026-04-07%20at%206.27.37%20PM.jpeg";
  const fullTitle = title ? `${title} | Jeekota` : "Jeekota - Community Crowdfunding & Discussions";
  const desc = description || "Test public interest before you fundraise. Launch validation campaigns, gather real pledges, and convert supporters into donors.";
  const url = path ? `${baseUrl}${path}` : baseUrl;
  const img = image || defaultImage;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export { SEO };
